import { isWeb } from "@helpers/platform";
import {
	type PropsWithChildren,
	createContext,
	useCallback,
	useContext,
	useMemo,
	useState,
} from "react";

type OverlayContextType = {
	isOverlayOpen: boolean;
	setOverlayOpen: (open: boolean) => void;
};

const OverlayContext = createContext<OverlayContextType | undefined>(undefined);

export const OverlayProvider = ({ children }: PropsWithChildren) => {
	const [isOverlayOpen, setOverlayOpen] = useState(false);

	const handleSetOverlayOpen = useCallback((open: boolean) => {
		if (isWeb) {
			setOverlayOpen(open);
		}
	}, []);

	const contextValue = useMemo(
		() => ({ isOverlayOpen, setOverlayOpen: handleSetOverlayOpen }),
		[isOverlayOpen, handleSetOverlayOpen],
	);
	return (
		<OverlayContext.Provider value={contextValue}>
			{children}
		</OverlayContext.Provider>
	);
};

export const useOverlay = () => {
	const context = useContext(OverlayContext);
	if (!context) {
		throw new Error("useOverlay must be used within OverlayProvider");
	}
	return context;
};
